<div class="tk-stela-notif-wrap">
  <button type="button" class="tk-stela-notif-trigger" (click)="notifPopover.toggle($event)">
    <i class="pi pi-bell"></i>
    @if (badgeCount() > 0) {
      <span class="tk-stela-notif-badge">{{ badgeCount() }}</span>
    }
  </button>
  <p-popover #notifPopover>
    <div class="tk-stela-notif-panel">
      <div class="tk-stela-notif-header">
        <span class="tk-stela-notif-title">{{ 'app.topbar.notifications' | translate }}</span>
        <span class="tk-stela-notif-count">{{ 'app.topbar.notifications_new_count' | translate: { count: badgeCount() } }}</span>
      </div>
      <div class="tk-stela-notif-list">
        @for (item of notifications(); track item.id) {
          <button type="button" class="tk-stela-notif-item" (click)="onNotificationClick(item, notifPopover)">
            <span class="tk-stela-notif-icon" [attr.data-variant]="item.variant">
              <i [class]="item.icon"></i>
            </span>
            <span class="tk-stela-notif-content">
              <span class="tk-stela-notif-message">{{ item.message }}</span>
              <span class="tk-stela-notif-time">{{ item.timestamp | relativeTime }}</span>
            </span>
          </button>
        } @empty {
          <p class="tk-stela-notif-empty">{{ 'app.topbar.notifications_empty' | translate }}</p>
        }
      </div>
      <button type="button" class="tk-stela-notif-footer" (click)="onViewAll(notifPopover)">
        {{ 'app.topbar.notifications_view_all' | translate }}
      </button>
    </div>
  </p-popover>
</div>
